import React, { useContext } from 'react'
// import cartContext from './threedcontext';

const AppContext3D = React.createContext()


// AppProvider = ({ children })
const ThreedProvider = ({ children }) => {

  const defaultthreeDstate = {
    items:[]
  }


  var productStateSelectContext = {
    "cooktopCategory":"SCH2443GB",
    "dishwasherCategory":"SDW6757ES",
    // "microwaveDrawerOvensCategory":"SMD2499FS",
    "microwaveDrawerOvensCategory":"SMD2489ES",
    "overRangeMicroCategory":"SMO1461GS",
    // "overRangeMicroCategory":"",
    "overTheCounterCategory":"R1214TY",
    "hoodRangeCategory":"SHC2432FS",
    "refrigeratorCategory":"SJB1255GS",
    // "wallOvenCategory":"SWA2450GS",
    "wallOvenCategory":"SSC2489GS",
    // "underTheCounterPedestalsCategory":"SKCD24U0GS",
    "underTheCounterPedestalsCategory":"SKMD24U0ES",
    // "underTheCounterPedestalsCategoryZoneThree" : "",
    'currentCam':"reset",
    'currentCamtwo':"reset",
    'currentProductVisibilitySequence':"",
    // 'currentProductVisibilitySequencewalloven':"B1_microdrawer_SWA2450GS_vis",
    'currentProductVisibilitySequencewalloven':"A1_walloven_SSC2489GS_vis",
    // 'currentProductVisibilitySequencetwo':"B1_SWA2450GS_AST_Zone3",
    'currentProductVisibilitySequencetwo':"A1_SSC2489GS_Zone3",
    'previousCam':'',
    'wallOvenmodel':"",
    'accordionId':"",

    'opacityFlag':"",

    'VisibilitySeqwallOven':"",
    'wallovenproduct':"",
  
    'microWaveDrawer':"",
    // "categoryPosition":"",

    "wallOvenPosition":"zoneSeven",
    // "pedestalsPosition":"zoneSeven",
    "pedestalsPosition":"",
    // "pedestalsPosition":"zoneThree",
    "popUpStatusWalloven":"",

    "previousPedestalZone":"",

    // "wallOvenPositionZoneThreeInitially":"None",

    "cardClickDatainhandleAccordion":"",

    "wallovencardClickDatainhandleAccordionZoneThree":"",
    "wallovenCamValueZoneThreeTohandleAccordion":"",

    "wallovenZoneThreeSeqValuefromAccordion":"",
    "microwaveVisibilityOffSequencefromProductCardClick":"",
    
    "microWaveSeqUpdateSMD2489ES":"",
    "microWaveSeqUpdateSMD2470AS":"",

    "wallOven2489GSValue":"",
    "wallOven2489PopUp":"",

    // "microWaveValueToProductCard":"A1_microdrawer_SMD2499FS_vis" // commented coz causing an issue
    "microWaveValueToProductCard":"",
    "microWaveSeqUpdateSMD2489ES":"",
    "zoneSevenPedestalRemovedStatus":false,
    "zoneThreePedestalRemovedStatus":{
      "SKCD24U0GS":false,
      "SKMD24U0ES":false
    },
 }
 

    return (
      <AppContext3D.Provider
          value={{productStateSelectContext}}>
          {children}
      </AppContext3D.Provider>
  )
}

export const use3DContext = () => {
  return useContext(AppContext3D)
}

export {ThreedProvider,AppContext3D};

// productStateSelectContext[productStateSelectContext.cooktopCategory]=